class ProviderUtils {
  static hostOnly(props) {
    const { providerName, metricsPlatform } = props;
    switch (providerName) {
      case "AWS":
        return metricsPlatform === "Host";

      default:
        return false;
    }
  }

  static memoryUnits(providerName) {
    switch (providerName) {
      case "AWS":
        return "GiB";

      default:
        return "GiB";
    }
  }

  static diskUnits(providerName) {
    switch (providerName) {
      case "AWS":
        return "MiB/s";

      default:
        return "MBps";
    }
  }

  static dsConfigs(providerName, configsData) {
    switch (providerName) {
      case "AWS":
        return configsData?.awsConfigs;

      case "STANDALONE":
        return configsData?.saConfig;

      default:
        return configsData?.configs;
    }
  }
}

export default ProviderUtils;
